import { Dialog as SheetPrimitive } from '@base-ui/react/dialog';

import { cn } from '@/lib/utils';

export type SheetOverlayProps = SheetPrimitive.Backdrop.Props;

const SheetOverlay = ({ className, ...props }: SheetOverlayProps) => {
  return (
    <SheetPrimitive.Backdrop
      data-slot="sheet-overlay"
      className={cn(
        'fixed inset-0 z-1100 transition-opacity',
        'bg-black/50 duration-150 supports-backdrop-filter:backdrop-blur-xs',
        'data-ending-style:opacity-0 data-starting-style:opacity-0',
        className,
      )}
      {...props}
    />
  );
};

export default SheetOverlay;
